import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api.js';
import { Logo } from '../components/Logo.jsx';

export default function Setup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    tenantNombre: '',
    tenantNit: '',
    tenantTipoNegocio: 'motel',
    tenantCiudad: '',
    adminNombre: '',
    adminPin: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.setup(form);
      setDone(true);
      setTimeout(() => navigate('/login'), 1800);
    } catch (err) {
      setError(err.message === 'already_initialized' ? 'Ya hay una empresa registrada en esta cuenta.' : 'No se pudo inicializar.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="text-6xl mb-6">✨</div>
          <div className="text-4xl font-bold tracking-tight mb-3">Empresa lista.</div>
          <p className="text-muted">Te redirijo al login en un momento…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-xl">
        <div className="mb-10 text-center">
          <div className="inline-flex"><Logo size={56} withWordmark /></div>
          <p className="eyebrow mt-8 mb-2">Inicializar</p>
          <h1 className="text-4xl font-bold tracking-tight mb-3">Crear empresa.</h1>
          <p className="text-muted">Solo se hace una vez. Después se administra todo desde el dashboard.</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div className="card space-y-5">
            <div className="flex items-center gap-2">
              <span className="pill-ink">1</span>
              <p className="eyebrow">Empresa</p>
            </div>
            <div>
              <label className="label">Nombre comercial</label>
              <input className="input" value={form.tenantNombre} onChange={upd('tenantNombre')} placeholder="Motel El Escondite" required />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="label">NIT (opcional)</label>
                <input className="input" value={form.tenantNit} onChange={upd('tenantNit')} placeholder="901.234.567-8" />
              </div>
              <div>
                <label className="label">Ciudad</label>
                <input className="input" value={form.tenantCiudad} onChange={upd('tenantCiudad')} placeholder="Tuluá" />
              </div>
            </div>
            <div>
              <label className="label">Tipo de negocio</label>
              <select className="input" value={form.tenantTipoNegocio} onChange={upd('tenantTipoNegocio')}>
                <option value="motel">Motel</option>
                <option value="hotel">Hotel</option>
                <option value="restaurante">Restaurante</option>
                <option value="tienda">Tienda</option>
                <option value="otro">Otro</option>
              </select>
            </div>
          </div>

          <div className="card space-y-5">
            <div className="flex items-center gap-2">
              <span className="pill-ink">2</span>
              <p className="eyebrow">Tu acceso de administrador</p>
            </div>
            <div>
              <label className="label">Tu nombre</label>
              <input className="input" value={form.adminNombre} onChange={upd('adminNombre')} placeholder="Diana" required />
            </div>
            <div>
              <label className="label">PIN (mínimo 4 dígitos)</label>
              <input className="input text-center text-2xl tracking-widest" type="password" value={form.adminPin} onChange={upd('adminPin')} inputMode="numeric" minLength={4} maxLength={6} required />
            </div>
          </div>

          {error && (
            <div className="rounded-2xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-800 font-mono">
              {error}
            </div>
          )}

          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'Creando…' : 'Crear empresa →'}
          </button>
        </form>
      </div>
    </div>
  );
}
